<h2 mat-dialog-title>{{ actionLabel }} alert</h2>

<form [formGroup]="form" (ngSubmit)="submit()">
    <mat-dialog-content>
        <p class="alert-action-dialog__subject">{{ data.subject }}</p>
        <p>{{ consequence }}</p>

        <mat-form-field class="alert-action-dialog__comment">
            <mat-label>Comment (optional)</mat-label>
            <textarea #commentBox matInput formControlName="comment" rows="3"></textarea>
            <mat-hint>Shown on this page only, never in Telegram.</mat-hint>
            <mat-hint align="end">{{ form.controls.comment.value.length }} / {{ commentMaxLength }}</mat-hint>
            @if (form.controls.comment.hasError("maxlength")) {
                <mat-error>At most {{ commentMaxLength }} characters</mat-error>
            }
        </mat-form-field>

        @if (errorMessage(); as text) {
            <div class="alert-action-dialog__answer" role="alert">{{ text }}</div>
        }
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button type="button" [disabled]="isSending()" (click)="cancel()">Cancel</button>
        <button mat-flat-button type="submit" [disabled]="!canSubmit()" [attr.aria-busy]="isSending() ? 'true' : null">
            {{ actionLabel }}
        </button>
    </mat-dialog-actions>
</form>
